import React from "react";
import "./WhurzIt.css"

const WhurzItOneB = () => (
  <div>

	<h1>Single Page Application</h1>
    <p>WhurzIt is not a React application, but it is a single page application
    nonetheless.  React single page applications make use of React router to 
    present multiple screens.  The same behavior can be implemented in a non-React
    application by setting all but one of the application's divs to have a 
    display attribute of none.  Then, as the user selects different navigation 
    links, change which divs have their display attribute set to either block or 
    none.  This is how WhurzIt implements the single page behavior.</p>

	
  </div>
);

export default WhurzItOneB;


// WEBPACK FOOTER //
// ./src/components/WhurzIt/WhurzItOneB.js